/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-09-18 18:01:06
 * @LastEditors: caiqin.xie
 * @message: 门店-线下店
 */
import React from "react";
import ShopItem from "../ShopItem";
import styles from "../../index.module.scss";
import { IShop } from "@/common/types";

interface IProps {
  offlineList: IShop[]; // 线下店列表
  total: number; // 总条数
  ctry: string;
  words: Record<string, string>;
}

const OfflineShop = (props:IProps) => {
  const {ctry, words, offlineList, total} = props

  return (
    <>
      {offlineList && offlineList.length > 0 && (
        <section className={styles['offline-store']}>
          <h2>{words?.shop_offline_title}</h2>
          {/* Offline stores in United */}
          <div className={styles['store-list']}>
            {offlineList.slice(0, 2).map((item: IShop, index) => (
              <div className={styles['store-item']}  key={item.id}>
                <ShopItem shopData={item}></ShopItem>
              </div>
            ))}
          </div>
          {total > 2 && (
            <p className={styles["more-store"]}>
              <a href={`/${ctry}/shop/offline-shop`}>
                <span className={styles["learn-more-purple"]}>{words?.common_learn_more}</span>
                {/* Learn More */}
              </a>
            </p>
          )}
        </section>
      )}
    </>

  )
}
export default OfflineShop
